// import format from 'date-fns/format';
import { toDate, format } from 'date-fns';

/**
 * Create string from Date. Uses UTC format if no format string is specified.
 * Important notice: fnsFormat() sets the day of the date off by one.
 * Wrapping the date passed to formatDate() with addDays(sampleDate, daysToAdd) will help fix the issue.
 */
export function formatDate(
  value?: Date | number | null,
  dateFormat?: string,
  defaultValue = ''
): string {
  if (!value) {
    return defaultValue;
  }

  try {
    return dateFormat ? format(value, dateFormat) : toDate(value).toISOString();
  } catch {
    return defaultValue;
  }
}
